<template>
  <section v-if="result && +result.elementsCount" class="catalog-pagination">
    <div class="progress">
      <p class="progress__text">
        {{ result.showedCount }}
      </p>
    </div>

    <a
      v-if="+result.pageNumber + 1 <= result.pageCount"
      :href="getPageUrl(+result.pageNumber + 1)"
      rel="canonical"
      class="add-more-button"
      @click.prevent="handlerAddMore"
    >
      <DefButtonPrimary>{{ result.showMoreCount }}</DefButtonPrimary>
      <span class="arrow">
        <svg viewBox="0 0 20 20" class="arrow__icon">
          <path
            d="M9.43728 17.3427C9.59434 17.4997 9.80733 17.5879 10.0294 17.5879C10.2515 17.5879 10.4645 17.4997 10.6215 17.3427L15.3594 12.6048C15.4393 12.5276 15.5032 12.4352 15.547 12.333C15.5909 12.2308 15.614 12.1209 15.615 12.0097C15.616 11.8985 15.5948 11.7882 15.5527 11.6853C15.5106 11.5824 15.4484 11.4889 15.3697 11.4102C15.2911 11.3316 15.1976 11.2694 15.0947 11.2273C14.9917 11.1852 14.8815 11.164 14.7702 11.1649C14.659 11.1659 14.5491 11.189 14.447 11.2329C14.3448 11.2768 14.2524 11.3406 14.1751 11.4206L10.8669 14.7288V3.63756C10.8669 3.41544 10.7787 3.20242 10.6216 3.04535C10.4646 2.88829 10.2515 2.80005 10.0294 2.80005C9.80728 2.80005 9.59426 2.88829 9.43719 3.04535C9.28013 3.20242 9.19189 3.41544 9.19189 3.63756V14.7288L5.8837 11.4206C5.72575 11.268 5.51419 11.1836 5.29459 11.1855C5.075 11.1874 4.86494 11.2755 4.70966 11.4308C4.55438 11.5861 4.4663 11.7961 4.46439 12.0157C4.46248 12.2353 4.5469 12.4469 4.69946 12.6048L9.43728 17.3427Z"
          />
        </svg>
      </span>
    </a>
    <div class="pagination">
      <a
        :href="getPageUrl(result.pageNumber - 1 ? result.pageNumber - 1 : 1)"
        rel="canonical"
        class="pagination__item pagination__prev"
        @click.prevent="handlerClick(result.pageNumber - 1)"
      >
        <svg><use xlink:href="#svg-arrow-left"></use></svg>
      </a>
      <span v-for="item in createPaginationArray" class="">
        <a
          v-if="typeof item === 'number'"
          :href="getPageUrl(item)"
          :class="{ pagination__item_active: item == result.pageNumber }"
          rel="canonical"
          class="pagination__item"
          @click.prevent="handlerClick(item)"
        >
          {{ item }}
        </a>
        <span v-else class="pagination__item">
          {{ item }}
        </span>
      </span>

      <a
        :href="
          getPageUrl(
            +result.pageNumber + 1 <= result.pageCount ? +result.pageNumber + 1 : +result.pageNumber
          )
        "
        rel="canonical"
        class="pagination__item pagination__next"
        @click.prevent="handlerClick(+result.pageNumber + 1)"
      >
        <svg><use xlink:href="#svg-arrow-right"></use></svg>
      </a>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import useScreenWidth from '@use/useScreenWidth';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';

export default {
  name: 'CatalogPagination',
  components: { DefButtonPrimary },
  props: ['result'],
  data() {
    return {
      screenWidth: useScreenWidth(),
    };
  },
  computed: {
    ...mapState({
      messages: ({ results }) => results.messages,
    }),
    maxCounter() {
      if (+this.result.pageNumber <= 2) {
        return 3;
      }
      if (+this.result.pageCount - 2 < +this.result.pageNumber) {
        return 3;
      }
      return this.screenWidth >= 768 ? 3 : 1;
    },
    createPaginationArray() {
      try {
        const paginationArray = [];
        const maxCounter = +this.result.pageNumber + +this.maxCounter - +this.result.pageNumber;

        let startCount =
          (this.screenWidth >= 768 ? +this.result.pageNumber - 1 : +this.result.pageNumber) || 1;
        // add 3 elements in the end.
        if (
          +this.result.pageCount - 2 > 0 &&
          +this.result.pageCount - 2 < +this.result.pageNumber
        ) {
          startCount = +this.result.pageCount - 2;
        }
        // if pages less then 3
        if (+this.result.pageCount <= 3) {
          startCount = 1;
        }
        // добавляем переход на первую страницу
        if (startCount >= this.maxCounter) {
          paginationArray.push(1);
          paginationArray.push('...');
        }
        // создаем оставшуюся часть для пагинации
        for (let i = startCount; i <= +this.result.pageCount; i++) {
          // console.log(i, maxCounter + startCount);
          if (i < maxCounter + startCount) {
            paginationArray.push(i);
          } else if (i === maxCounter + startCount + 1) {
            if (+this.result.pageCount - +this.result.pageNumber + 2 > +this.maxCounter) {
              paginationArray.push('...');
            }
            paginationArray.push(this.result.pageCount);
          }
        }
        return paginationArray;
      } catch (err) {
        console.error(err);
        return [];
      }
    },
  },
  methods: {
    scrollTop() {
      const scrollToElement = document.querySelector('.pagination-scroll-js');
      if (scrollToElement) {
        App.helpers.scrollPageTo(scrollToElement.offsetTop - 60);
      }
    },
    async handlerAddMore() {
      const { pageNumber, pagingKey } = this.result;

      const query = {
        ...this.$route.query,
        [pagingKey]: +pageNumber + 1,
      };

      await this.$router.replace({ path: this.$route.path, query });

      this.$emit('addMore', this.$route.fullPath);
    },
    async handlerClick(item) {
      const { pageNumber, pageCount, pagingKey } = this.result;

      if (item == 0 || pageNumber == item || pageCount < item || typeof item !== 'number') return;

      const query = {
        ...this.$route.query,
        [pagingKey]: item,
      };

      await this.$router.replace({ path: this.$route.path, query });

      this.$emit('change', this.$route.fullPath);
      this.scrollTop();
    },
    getPageUrl(page) {
      const { pagingKey } = this.result;
      const re = new RegExp(`${pagingKey}=[0-9]+&?`);
      const str = this.$route.fullPath.match(re);

      const pageStr = `${pagingKey}=${page}`;

      if (!str) {
        return `${this.$route.fullPath}?${pageStr}`;
      }
      return this.$route.fullPath.replace(re, pageStr);
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-pagination {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
  @include point-md {
    align-items: center;
    padding-top: 24px;
    padding-bottom: 24px;
  }
  @include point-lg {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
}
.pagination {
  display: flex;
  gap: 6px;
  @include point-md {
    gap: 8px;
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    font-size: 16px;
    font-weight: 600;
    line-height: 125%;
    transition: 0.2s linear background-color;
    color: var(--color-dark-grey);
    border: 1px solid #c8c8c8;
    flex-shrink: 0;
    @include point-md {
      width: 44px;
      height: 44px;
      font-size: 18px;
    }
    &_active {
      background-color: var(--background-black);
      color: #fff;
    }
    svg {
      display: block;
      height: 24px;
      width: 24px;
    }
  }
  &__prev {
    margin-right: auto;
    @include point-md {
      margin-right: 16px;
    }
  }
  &__next {
    margin-left: auto;
    @include point-md {
      margin-left: 16px;
    }
  }
}
.progress {
  @include point-md {
    grid-column-start: 1;
    grid-column-end: 3;
  }
  @include point-lg {
    width: 100%;
  }
  &__text {
    color: var(--color-dark-grey);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
    text-align: center;
    @include point-md {
      font-size: 16px;
    }
  }
}
.add-more-button {
  display: flex;
  @include point-md {
    margin-bottom: 8px;
  }
  @include point-lg {
    margin-bottom: 0;
  }
  :deep(.def-button-primary) {
    flex-grow: 1;
    padding: 0 18px;
  }
}
.arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--background-black);
  padding: 0 18px;
  border-left: 1px solid var(--background-dark-grey);
  &__icon {
    width: 20px;
    height: 20px;
    fill: #fff;
  }
}
</style>
